module.exports = __webpack_public_path__ + "ie.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/4x3/ie.svg
// module id = 860
// module chunks = 0